import { render, staticRenderFns } from "./addFieldsModal.vue?vue&type=template&id=8b55b956&scoped=true"
import script from "./addFieldsModal.vue?vue&type=script&lang=js"
export * from "./addFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./addFieldsModal.vue?vue&type=style&index=0&id=8b55b956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b55b956",
  null
  
)

export default component.exports